module.exports = __webpack_public_path__ + "e3c1d1ddee960e514f331ad3f4868fc9.jpg";